
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { Parcel } from "./types";
import { processParcel } from "./utils";

/**
 * Hook to fetch a single parcel by ID
 */
export const useParcel = (id: string) => {
  return useQuery({
    queryKey: ['parcels', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('parcels')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;

      return processParcel(data) as Parcel;
    },
  });
};
